import React from 'react';

function Home() {
    return <div className="Home" style={{ visibility: 'hidden' }} />;
}

export default Home;
